import { DollarSign, Plus, Calendar, CheckCircle, AlertCircle } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { PageHeader } from '@/components/PageHeader';

export default function CollectionPaymentPlans() {
  const stats = [
    {
      title: "Active Plans",
      value: "0",
      description: "Currently active payment plans",
      icon: Calendar,
    },
    {
      title: "Completed",
      value: "0",
      description: "Successfully completed plans",
      icon: CheckCircle,
    },
    {
      title: "Defaulted",
      value: "0",
      description: "Plans in default status",
      icon: AlertCircle,
    },
    {
      title: "Total Value",
      value: "$0",
      description: "Combined plan amounts",
      icon: DollarSign,
    }
  ];

  return (
    <div className="space-y-6">
      <PageHeader
        title="Payment Plans"
        description="Manage customer payment plans and installment agreements"
        action={
          <Button className="gap-2">
            <Plus className="h-4 w-4" />
            New Payment Plan
          </Button>
        }
      />

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <Card key={index}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium text-muted-foreground">
                {stat.title}
              </CardTitle>
              <stat.icon className="h-4 w-4 text-muted-foreground" />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{stat.value}</div>
              <p className="text-xs text-muted-foreground">
                {stat.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Payment Plans */}
      <Card>
        <CardHeader>
          <CardTitle>Payment Plans</CardTitle>
          <CardDescription>
            Create and manage flexible payment arrangements for customers
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-center py-12">
            <DollarSign className="h-16 w-16 text-muted-foreground mx-auto mb-4" />
            <h3 className="text-lg font-semibold mb-2">No payment plans</h3>
            <p className="text-muted-foreground mb-4">
              Create flexible payment plans to help customers manage their bill payments
            </p>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Create Payment Plan
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}